<template>
  <div id="data-area-view" class="custom-scrollbar-grey ">
    <HeaderContent :title="$t('data.title')">
      <div slot="main">
        <p class="text-muted" v-html="$t('data.message')"></p>
      </div>
      <div slot="menu">
        <div class="main-actions">
          <dropdown class="dropdown" v-if="contentTypes.length > 0" forceDown>
            <div slot="toggle" class="toggle-wrapper">
              <span class="filter-icon">
                <i class="fa-light fa-filter"></i>
              </span>
              <button class="selected-filter-btn">
                <span>
                  {{ selectedType.name }}
                </span>
                <span class="chevron">
                  <i class="fa-light fa-chevron-down"></i>
                </span>
              </button>
            </div>

            <button
              tabindex="0"
              class="dropdown-item"
              v-for="contentType in contentTypes"
              :key="contentType.id + contentType.custom"
              @click.stop.prevent="onSourceSelected(contentType)"
              :class="{ active: contentType.id == selectedType.id }"
            >
              {{ contentType.name }}
            </button>
          </dropdown>
          <div v-else></div>

          <button class="btn btn-md btn-primary btn-flex " @click="newIntegration">
            <i class="fa-light fa-plus"></i> Integration
          </button>
        </div>
      </div>
    </HeaderContent>

    <div id="data-area" class="d-flex flex-grow-1 align-items-stretch ">
      <div class="data-picker flex-grow-1 auto-max-width">
        <ContentSourceView
          v-if="selectedType && contentTypes.length"
          :contentSources="contentSources2"
          :fixedIntegrations="fixedSources"
          :currentType="selectedType"
          :matchingSources="findMatchingSources"
          :walkthrough="started"
          :primarySource="this.findMatchingSources.find((f) => f.id == this.findPrimarySource)"
          @update-selected="updateSelectedType"
          @count-uploads="countUploads"
        />
        <div class="no-content" v-if="contentTypes.length == 0">
          <span>{{ $t("data.no-content") }}</span>
          <br />
          <a target="_blank" href="https://help.icrobotics.com/getting-started">{{ $t("template.guide-link") }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appHelper from "@/assets/js/appHelper.js";
import NewIntegrationModal from "@/components/modals/NewIntegrationModal";
import ContentSourceView from "@/components/ContentSourceView";
import HeaderContent from "@/components/HeaderContent.vue";
export default {
  name: "data-area",
  data() {
    return {
      newContentType: "",
      searchFilter: "",
      selectedType: null,
      collapsed: true,
      started: true,
      succes: false,
      dummyUploadsCount: 0,
      sidePanelOpen: false
    };
  },
  methods: {
    newIntegration() {
      this.$modal.show(
        NewIntegrationModal,
        {
          onCreateCustomIntegration: (source) => {
            this.$store
              .dispatch("createContentType", source.name)
              .then((result) => {
                // this.newContentType = ""
                source.type = result.body;
                const customSource = JSON.stringify(source);
                this.$store
                  .dispatch("createSource", customSource)
                  .then(() => {
                    this.updateSelectedType();
                    // this.showNotice();
                  })
                  .catch((error) => {
                    this.error = true;
                  });
              })
              .catch((error) => {});
          },

          onCreateFixed: (integration) => {
            this.$store.dispatch("getIntegrationSettings", [integration]).then((res) => {
              this.$store
                .dispatch("createFixedIntegration", {
                  integrationEnumName: integration,
                  settings: res[appHelper.toCamelCase(integration)]
                })
                .then((result) => {
                  this.selectedType = this.contentTypes.find((t) => t.name == result.enumName);
                })
                .catch((error) => {
                  this.error = true;
                });
            });
          }
        },
        { width: 403, height: "auto", adaptive: true }
      );
    },

    onSourceSelected(contentType) {
      this.selectedType = contentType;
    },

    updateSelectedType() {
      let typeLength = this.contentTypes.length - 1;
      this.onSourceSelected(this.contentTypes[typeLength]);
    },

    countUploads(c) {
      this.dummyUploadsCount = c;
      // this.$emit("count-uploads", c)
    }
  },
  computed: {
    contentTypes() {
      return this.$store.state.contentTypes;
    },
    contentSources() {
      return this.$store.state.contentSources;
    }, // integrations (contentsources) with fixed integrations (shopify - enetpulse etc.)
    contentSources2() {
      return this.$store.state.contentSources2;
    }, // integrations WITHOUT fixed integrations

    findPrimarySource() {
      if (this.findMatchingSources.length == 0) return null;
      let each = this.findMatchingSources.map((f) => f.id);
      let min = Math.min.apply(Math, each);
      return min;
    },
    fixedSources() {
      // let fixed = this.contentSources.filter(source => source.contentType.custom == false) // finding the fixedSources based on their contentTypes.custom bool instead of their ids.
      let fixed = [];
      //Finding all fixed source by firstly sorting away custom sources and then sorting away custom sources that are connected to fixed contentTypes
      this.contentSources
        .filter((source) => source.contentType.custom == false)
        .map((s) => {
          // if(!this.contentSources2.some(source => source.id == s.id)){ // removed because its already filterede the right way
          if (s.enumName !== "Custom") {
            (s.fixedIntegration = true), (s.dummy = false);
            fixed.push(s);
          }
          // }
        }); // s.dummy = false is so that "Type" sorting works in ContentSourceView.vue
      return fixed;
    },
    findMatchingSources() {
      let fixed = this.fixedSources.filter(
        (source) => source.contentType.id == this.selectedType.id && source.contentType.name == this.selectedType.name
      );
      let customs = this.contentSources2.filter(
        (source) => source.contentType.id == this.selectedType.id && source.contentType.name == this.selectedType.name
      );
      return customs != 0 || fixed != 0 ? fixed.concat(customs) : [];
    },
    fixedIntegrationCreated() {
      if (this.contentTypes.length != 0 && this.contentTypes[0].custom == false) {
        return true;
      } else return false;
    }
  },
  created() {
    if (this.contentTypes) {
      // this.selectedType = this.contentTypes.filter(type => type.custom)[0] || this.contentTypes[0]
      this.selectedType = this.contentTypes[0] || this.contentTypes.filter((type) => type.custom)[0];
    }
  },
  components: {
    ContentSourceView,
    HeaderContent
  }
};
</script>

<style lang="less">
#data-area-view {
  overflow: auto;
  background-color: var(--bg-grey);
  .main-actions {
    margin: 12px 0;
    display: flex;
    gap: 12px;
    justify-content: space-between;

    .toggle-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      background: #fff;
      border-radius: 20px;
      padding: 6px 16px;
      box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.25);
      button {
        outline: none;
        background: transparent;
        border: none;
      }
    }
  }
}
#data-area {
  .integrations {
    // background-color: var(--alabaster);
    background-color: var(--background-white);
    box-shadow: 2px 0 4px 0 rgba(0, 0, 0, 0.25);
    width: 240px;
    padding: 24px 40px 40px 40px;
    overflow: auto;
    h1 {
      margin-bottom: 50px;
    }
    .sources {
      overflow: auto;
      .source {
        font-size: 13px;
        font-weight: 500;
        color: #8f979c;
        cursor: pointer;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0;

        &.active {
          color: var(--flame);
          span {
            text-decoration: underline var(--flame);
          }
        }
        &:hover {
          // background-color: rgba(235, 235, 235, 0.521);
          > .trashcan {
            display: flex;
            align-items: center;
          }
        }
      }

      .trashcan {
        display: none;
        height: 12px;
      }
    }
  }
  .create-source {
    form {
      display: grid;
      grid-template-columns: 2;
      align-items: center;
      margin: 20px 0;
    }
    input {
      border: none;
      margin-left: 6px;
      grid-column-start: 2;
      max-width: 170px;
      &::placeholder {
        color: rgb(117, 117, 117);
      }
    }

    .new-category {
      font-size: 18px;
      font-weight: 400;
      color: rgb(117, 117, 117);
      border: none;
      background-color: transparent;
      // border: 1px solid #8F979C;
      border-radius: 50%;
      padding: 0px 6px;
      grid-column-start: 1;
      grid-row-start: 1;
    }

    input:focus + .new-category {
      color: var(--orange-web);
    }
  }

  .data-picker {
    padding-top: 36px;
    padding: 36px 12px;
    padding-bottom: 36px;

    .source-heading {
      margin: 0 40px;
      position: relative;
    }
  }

  .list-header {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;
  }

  .no-content {
    text-align: center;
    font-size: 14px;
    color: #8f979c;
    line-height: 25px;
    padding-top: 30px;
  }
}
</style>
